import { Component } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GenericConfirmModalParams } from '../generic-confirm-modal/generic-confirm-modal-params';
import { GenericConfirmModalComponent } from '../generic-confirm-modal/generic-confirm-modal.component';

/**
 * Opens the GenericConfirmModal with Unsaved Changes information.
 */
@Component({
  selector: 'zbp-unsaved-changes-modal',
  template: '',
})
export class UnsavedChangesModalComponent {

  /**
   * Opens GenericConfirmModal with Unsaved Changes text with Cancel and Confirm buttons.
   *
   * Text and most styling cannot be customized through params in order to make UX consistent.
   *
   * BodyRef Option and Size Option in params can be customized.
   *
   * @param {GenericConfirmModalParams} params
   * @returns {NgbModalRef} Modal Ref
   */
  static open(modalService: NgbModal, params: GenericConfirmModalParams = null): NgbModalRef {
    const modalRef =  GenericConfirmModalComponent.open(modalService, params);
    const component = modalRef.componentInstance;

    component.params = {
      body: 'You have unsaved changes, please click confirm to continue.',
      confirm: { label: 'Confirm' },
      cancel: {
        label: 'Cancel',
        iconPosition: 'right',
        enabled: true,
      },
      options: {
        size: params?.options?.size ?? 'lg',
      }
    };
    return modalRef;
  }
}
